export const isValidEmail = (value) =>
  typeof value === 'string' &&
  value.length <= 254 &&
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

export const validateRegister = ({ old, values, step }) => {
  const requiredStep1 = ['first_name', 'last_name', 'email'];
  const requiredStep2 = ['id', 'category'];
  const requiredStep3 = ['marketplace', 'purchase_date', 'order_number'];
  let required = [];
  switch (step) {
    case 1:
      required = requiredStep1;
      break;
    case 2:
      required = requiredStep2;
      break;
    case 3:
      required = values.needUser
        ? [...requiredStep3, 'set_password', 'password2']
        : requiredStep3;
      break;
    default:
      break;
  }

  const passwordCheck = (password) => {
    return /\d/.test(password) && /\p{L}/u.test(password);
  };

  const isArray = Array.isArray(old);
  let newValues = isArray ? [] : {};
  let found = false;
  if (isArray) {
    newValues = old.map((product, i) => {
      const item = {};
      for (const key in product) {
        if (required.includes(key)) {
          if (!values[i][key]) {
            item[key] = { filled: true, message: 'empty field' };
            found = true;
            continue;
          }
        }

        item[key] = { filled: false, message: '' };
      }
      return item;
    });
  } else {
    for (const key in old) {
      if (required.includes(key)) {
        if (!values[key]) {
          newValues[key] = { filled: true, message: 'empty field' };
          found = true;
          continue;
        } else if (key === 'email') {
          if (!isValidEmail(values[key])) {
            newValues[key] = {
              filled: true,
              message: 'incorrect email address',
            };
            found = true;
            continue;
          }
        } else if (key === 'set_password' || key === 'password2') {
          if (values.set_password !== values.password2) {
            newValues[key] = {
              filled: true,
              message: 'passwords do not match',
            };
            found = true;
            continue;
          }

          if (values[key].length < 7) {
            newValues[key] = {
              filled: true,
              message: 'password must be at least 7 characters',
            };
            found = true;
            continue;
          }

          if (!passwordCheck(values[key])) {
            newValues[key] = {
              filled: true,
              message:
                'password must contain both alphabetic and numeric characters',
            };
            found = true;
            continue;
          }
        }
      }

      newValues[key] = { filled: false, message: '' };
    }
  }

  return { newValues, preventChange: found };
};

export const validateCase = ({ old, values, step }) => {
  const requiredStep1 = ['first_name', 'last_name', 'email', 'country'];
  const requiredStep2 = ['product_id', 'category'];
  const requiredStep3 = ['marketplace', 'purchase_date', 'order_number'];
  let required = [];
  switch (step) {
    case -1:
      required = ['email'];
      break;
    case 0:
      required = ['item'];
      break;
    case 1:
      required = requiredStep1;
      break;
    case 2:
      required = requiredStep2;
      break;
    case 3:
      required = requiredStep3;
      break;
    case 4:
      required = ['case_description'];
      break;
    default:
      break;
  }

  let newValues = {};
  let found = false;

  for (const key in old) {
    if (required.includes(key)) {
      if (!values[key]) {
        newValues[key] = { filled: true, message: 'empty field' };
        found = true;
        continue;
      } else if (key === 'email') {
        if (!isValidEmail(values[key])) {
          newValues[key] = {
            filled: true,
            message: 'incorrect email address',
          };
          found = true;
          continue;
        }
      }
    }

    newValues[key] = { filled: false, message: '' };
  }

  return { newValues, preventChange: found };
};

export const marketplaces = [
  'Amazon',
  'eBay',
  'Walmart',
  'Retail Store',
  'GunBroker',
  'GritrSports.com',
  'GritrOutdoors.com',
  'GritrGear.com',
];

export const formatMySQLdate = (custom) => {
  return custom.toISOString().slice(0, 19).replace('T', ' ');
};

export const formatUSdate = (d) =>
  new Intl.DateTimeFormat('en-US', {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric',
  }).format(d);

export const getEmailBody = (data) => {
  const headers = [
    { key: 'email', label: 'Customer Email' },
    { key: 'first_name', label: 'First Name' },
    { key: 'last_name', label: 'Last Name' },
    { key: 'product_sku', label: 'Product SKU' },
    { key: 'product_name', label: 'Product Name' },
    { key: 'marketplace', label: 'Marketplace' },
    { key: 'purchase_date', label: 'Purchase Date' },
    { key: 'order_number', label: 'Order Number' },
    { key: 'case_description', label: 'Case Description' },
  ];

  let body = `<table style="border: 1px solid black;border-collapse: collapse;padding: 5px 10px; font-size: 14px;">
          <tr style="background-color: #ccc;">
            <th style="text-align: center;padding: 5px 10px;border: 1px solid black;">Name</th>
            <th style="text-align: center;padding: 5px 10px;border: 1px solid black;">Value</th>
          </tr>`;

  headers.forEach((h) => {
    if (data[h.key]) {
      body += `<tr>
        <td style="padding: 5px 10px;border: 1px solid black; text-align: left;">${
          h.label
        }</td>
        <td style="padding: 5px 10px;border: 1px solid black; text-align: left;">${
          h.key === 'purchase_date' ? formatUSdate(data[h.key]) : data[h.key]
        }</td>
      </tr>`;
    }
  });

  body += `</table><span style="opacity: 0">${new Date()}</span>`;
  return body;
};

export const fileTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
export const emailReceiver = 'cs@gritrgear.com';

export const calcDate = (days) => {
  const today = new Date();
  return new Date(today.setDate(today.getDate() - days));
};

export const headerNav = [
  {
    link: 'https://gritrgear.com/storage/holsters/',
    name: 'Holsters',
    values: [
      { link: 'https://gritrgear.com/gun-holsters/iwb/', name: 'IWB Holsters' },
      { link: 'https://gritrgear.com/gun-holsters/owb/', name: 'OWB Holsters' },
      {
        link: 'https://gritrgear.com/gun-holsters/appendix/',
        name: 'Appendix Holsters',
      },
      {
        link: 'https://gritrgear.com/gun-holsters/light-bearing/',
        name: 'Light Bearing Holsters',
      },
      {
        link: 'https://gritrgear.com/mag-carriers/',
        name: 'Mag Carriers',
      },
    ],
  },
  {
    link: 'https://gritrgear.com/firearm-accessories/',
    name: 'Firearm Accessories',
    values: [
      {
        link: 'https://gritrgear.com/optics/',
        name: 'Optics & Optic Plates',
      },
      {
        link: 'https://gritrgear.com/shotgun-accessories/',
        name: 'Shotgun Accessories',
      },
    ],
  },
  {
    link: 'https://gritrgear.com/gun-care/',
    name: 'Gun Care',
    values: [],
  },
  {
    link: 'https://gritrgear.com/additional-gear/',
    name: 'Additional Gear',
    values: [
      { link: 'https://gritrgear.com/knives/', name: 'Knives' },
      {
        link: 'https://gritrgear.com/apparel/',
        name: 'Apparel',
      },
      {
        link: 'https://gritrgear.com/protection/',
        name: 'Protection',
      },
    ],
  },
  {
    link: 'https://gritrgear.com/bags-cases/',
    name: 'Bags & Cases',
    values: [],
  },
  {
    link: 'https://gritrgear.com/camping/',
    name: 'Camping',
    values: [
      {
        link: 'https://gritrgear.com/titanium-cookware/',
        name: 'Titanium Cookwear',
      },
    ],
  },
  {
    link: 'https://gritrgear.com/more/',
    name: 'More',
    values: [
      {
        link: 'https://gritrgear.com/merch/',
        name: 'Merch',
      },
      {
        link: 'https://gritrgear.com/special-offers/',
        name: 'Special Offers',
      },
      {
        link: 'https://gritrgear.com/new-arrivals/',
        name: 'New Arrivals',
      },
      {
        link: 'https://gritrgear.com/best-sellers/',
        name: 'Best Sellers',
      },
    ],
  },
  {
    link: '/',
    name: 'Info',
    type: 'internal',
    values: [
      { link: '/', name: 'Warranty' },
      { link: 'https://gritrgear.com/contact-us/', name: 'Contact Info' },
      { link: '/', name: 'Journal' },
    ],
  },
];

export const footerColumns = [
  {
    heading: 'SHOP',
    items: [
      { label: 'Holsters', href: 'https://gritrgear.com/holsters/' },
      {
        label: 'Firearm Accessories',
        href: 'https://gritrgear.com/firearm-accessories/',
      },
      { label: 'Gun Care', href: 'https://gritrgear.com/gun-care/' },
      {
        label: 'Additional Gear',
        href: 'https://gritrgear.com/additional-gear/',
      },
      { label: 'Bags & Cases', href: 'https://gritrgear.com/bags-cases/' },
      { label: 'Camping', href: 'https://gritrgear.com/camping/' },
      { label: 'More', href: 'https://gritrgear.com/more/' },
    ],
  },
  {
    heading: 'LEARN',
    items: [
      { label: 'Contact Us', href: 'https://gritrgear.com/contact-us/' },
      { label: 'About Us', href: 'https://gritrgear.com/about-us/' },
      { label: 'Lifetime Warranty', href: 'https://warranty.gritrgear.com/' },
      { label: 'Partnership', href: 'https://gritrgear.com/partnership/' },
      {
        label: 'Affiliate Program',
        href: 'https://gritrgear.com/affiliate-program/',
      },
      {
        label: 'Press',
        href: 'https://gritrgear.com/press/',
      },
    ],
  },
  {
    heading: 'SUPPORT',
    items: [
      { label: 'FAQs', href: 'https://gritrgear.com/faqs/' },
      {
        label: 'Orders & Delivery',
        href: 'https://gritrgear.com/orders-and-delivery/',
      },
      {
        label: 'Returns & Refunds',
        href: 'https://gritrgear.com/returns-and-refunds/',
      },
      {
        label: 'Privacy & Security',
        href: 'https://gritrgear.com/privacy-and-security-policy/',
      },
      { label: 'ADA Statement', href: 'https://gritrgear.com/ada-statement/' },
      {
        label: 'Terms and Conditions',
        href: 'https://gritrgear.com/terms-and-conditions/',
      },
    ],
  },
  {
    heading: 'LOCATION',
    items: [
      {
        label: '7901 Boulevard 26 Ste 200\nNorth Richland Hills, TX, 76180',
        href: 'https://gritrgear.com/contact-us/#mapanchor',
        underline: true,
      },
      { label: 'Mon-Sat: 10AM-8PM;\nSun: 10AM-6PM', isText: true },
      {
        label: 'Phone: ',
        href: 'tel:866-515-0262',
        linkText: '866-515-0262',
        underline: true,
      },
      {
        label: 'Email: ',
        href: 'mailto:cs@gritrgear.com',
        linkText: 'cs@gritrgear.com',
        underline: true,
      },
      {
        label: 'Official',
        href: 'https://www.amazon.com/stores/GRITR/page/E831DA7B-E17E-42E0-B2C0-F1BDB4F822B2?maas=maas_adg_46DE3022DE6B03ED0D2C810E9B5E6E0B_afap_abs&ref_=aa_maas&tag=maas',
        linkText: 'Amazon Store',
        color: '#ff641C',
        underline: true,
      },
    ],
  },
];
